import Vue from 'vue';
import './layout.scss';
import layoutBase from '../layout-base.js';
import mstb from '../../modules/MSTB/mstb';
import mvtu from '../../modules/MVTU/mvtu';
new Vue({ extends: layoutBase, components: { mstb, mvtu } }).$mount('[data-layout-id="AELO-app"]');
